import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Formik } from 'formik';

import { ButtonSplitGroup } from '@components/Buttons';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  ProfileDataTable,
  ProfileDocumentsTable,
} from '@components/Numbers/Details/Table';
import { Page500 } from '@containers/ErrorPages';
import { checkIsReady } from '@features/queryUtils';
import { profileApi } from '@reducers/profile/profile';

export const ProfileForm = ({ did, profileID }) => {
  const [profile, setProfile] = useState(profileID);
  const profiles = profileApi.useGetForSelectQuery();
  const { data, isLoading, isFetching, isError } =
    profileApi.useGetProfileFormDataQuery({ id: profile, did });

  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }

  const handleProfileSelection = (e) => {
    setProfile(e.target.value);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{ profileID: profile }}
      onSubmit={() => {}}
    >
      {({ handleSubmit, handleChange, handleBlur, values }) => (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={4}>
              <Form.Group
                as={Row}
                className="mb-1"
                controlId="form.ControlProfile"
              >
                <Col>
                  <Form.Select
                    name="profileID"
                    value={values.profileID}
                    onChange={(e) => {
                      handleChange(e);
                      handleProfileSelection(e);
                    }}
                    disabled={profiles.isLoading || profiles.isFetching}
                    onBlur={handleBlur}
                  >
                    <option value="">
                      {profiles.isLoading ? 'Loading...' : 'Select end user'}
                    </option>
                    {checkIsReady(profiles)
                      ? profiles.data.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.name}
                          </option>
                        ))
                      : null}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
            <Col md={4}>
              <ButtonSplitGroup>
                <Button
                  variant="didxl"
                  size="sm"
                  as={Link}
                  to={`/profiles/edit/${values.profileID}`}
                >
                  Edit End user
                </Button>
              </ButtonSplitGroup>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={6}>
              <ProfileDataTable data={data.fields} did={did} />
            </Col>
            <Col md={6}>
              <ProfileDocumentsTable data={data.documents} did={did} />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};
